import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/checkout/return")({
  validateSearch: (search: Record<string, unknown>): { session_id?: string } => ({
    session_id: typeof search.session_id === "string" ? search.session_id : undefined,
  }),
  component: CheckoutReturn,
  head: () => ({ meta: [{ title: "Payment complete · Serenity" }] }),
});

function CheckoutReturn() {
  const { session_id } = Route.useSearch();
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="glass rounded-3xl p-8 max-w-md text-center space-y-4">
        <div className="text-3xl text-gradient">Thank you</div>
        {session_id ? (
          <>
            <p className="text-sm text-muted-foreground">
              Your payment was successful. If you booked a therapy session, it's now confirmed and visible on your sessions list. Premium features unlock automatically.
            </p>
            <div className="text-xs text-muted-foreground font-mono break-all">{session_id}</div>
          </>
        ) : (
          <p className="text-sm text-muted-foreground">No session information found.</p>
        )}
        <div className="flex gap-2 justify-center pt-2">
          <Link to="/dashboard" className="px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm">Back home</Link>
          <Link to="/therapists" className="px-4 py-2 rounded-lg bg-secondary text-sm">My sessions</Link>
        </div>
      </div>
    </div>
  );
}
